import React from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';

function formatWhen(value) {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

/**
 * "Edit history" under edited details: who changed what, and when, newest first.
 * `entries` are the server's { at, byType?, byName, byEmail, changes: [{ field, from, to }] }.
 */
export default function FieldEditHistory({ entries, labels = {}, formatValue = (field, v) => v }) {
  const list = Array.isArray(entries) ? [...entries].reverse() : [];
  if (!list.length) return null;
  return (
    <div className="mt-3 rounded-xl border border-slate-200 bg-white/70 px-3.5 py-2.5" data-testid="field-edit-history">
      <p className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-slate-500">
        <ClockIcon className="h-3.5 w-3.5" /> Edit history
      </p>
      <ul className="mt-1.5 max-h-36 space-y-2 overflow-y-auto pr-1">
        {list.map((e, i) => (
          <li key={`${e.at}-${i}`} className="text-[11px] text-slate-600">
            <p>
              <span className="font-semibold text-slate-800" title={e.byEmail || undefined}>
                {e.byName || e.byEmail || 'Unknown user'}
              </span>
              {e.byType === 'arm' && <span className="text-slate-500"> (ARM, via salary link)</span>}
              {e.byType === 'candidate' && <span className="text-slate-500"> (at upload, from the card read)</span>}
              <span className="text-slate-400"> · {formatWhen(e.at)}</span>
            </p>
            <ul className="mt-0.5 space-y-0.5 pl-3">
              {(e.changes || []).map((c) => (
                <li key={c.field} className="break-words">
                  <span className="text-slate-500">{labels[c.field] || c.field}:</span>{' '}
                  <span className="line-through decoration-slate-300">{formatValue(c.field, c.from) || '—'}</span>
                  {' → '}
                  <span className="font-semibold text-slate-800">{formatValue(c.field, c.to) || '—'}</span>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
}
